module.exports = __webpack_public_path__ + "img/2-WHEEL.add2a015.png";